import axios from "./axios";
const source = "tvi"

export const getPrice = (price_id) => {
    return new Promise((resolve, reject) => {
        axios.post("/user/get-price", { price_id })
            .then((response) => {
                resolve(response.data)
            })
            .catch((err) => {
                reject(err.response.data.message)
            })
    })
}
export const getPriceForVipProduct = (price_id) => {
    return new Promise((resolve, reject) => {
        axios.post("/user/get-vip-price", { price_id })
            .then((response) => {
                resolve(response.data)
            })
            .catch((err) => {
                reject(err.response.data.message)
            })
    })
}
export const codeIsValidCheckAndDetails = (code, productId) => {
    return new Promise((resolve, reject) => {
        axios.post("/user/vip-code-check", { code, productId })
            .then((response) => {
                resolve(response.data)
            })
            .catch((err) => {
                reject(err.response.data.message)
            })
    })
}
export const getTokenDetails = (coupon) => {
    return new Promise((resolve, reject) => {
        axios.post("/user/get-coupon-verified", { coupon })
            .then((response) => {
                resolve(response.data.data)
            })
            .catch((err) => {
                reject(err.response.data.message)
            })
    })
}